import api from './api';

export default class PeriodosService {
  constructor() {
    throw 'Não é possível instanciar PeriodosService';
  }

  static async lista(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    return await api.get(endpoint);
  }

  static async obtemDoFuncionario(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    const params = { idAvaliado: id };
    return await api.get(endpoint, { params });
  }
}

const mergeEndpoint = (id, idMes) => {
  return `avaliacoes-periodicas/avaliador/${id}/competencias/${idMes}/avaliacoes-periodicas`;
};



// WEBPACK FOOTER //
// ./src/services/periodosService.js